import { render, staticRenderFns } from "./AnnualReportDetails.vue?vue&type=template&id=2eb4b92a&scoped=true&"
import script from "./AnnualReportDetails.vue?vue&type=script&lang=js&"
export * from "./AnnualReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReportDetails.vue?vue&type=style&index=0&id=2eb4b92a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4b92a",
  null
  
)

export default component.exports